import { FC } from 'react'
import BaseSuccess from './BaseSuccess'

const ShowingProviderSuccess: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <BaseSuccess
      onClose={onClose}
      header="Showing Management Service Changed"
      message="Your showing management service has been successfully changed"
    />
  )
}

export default ShowingProviderSuccess
